/* Maybe move select element to chaild of conatiner to encapsuate all */

(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	jQuery.framework.select = function()
	{
		//get each select element
		jQuery("select").each(function()
		{
			sel_options_arr = [];
			
			jQuery(this).find("option").each(function(index)
			{
				html = jQuery(this).html();
				
				sel_options_arr[index] = {
					"name": jQuery(this).attr("name"),
					"html": "<div class='fw_option'>" + html + "</div>",
					"value": jQuery(this).attr("value"),
					"displayvalue": jQuery(this).html()
				};
			});

			placeholder = sel_options_arr[0].displayvalue;
			
			sel_container = "<div class='fw_select_container'></div>";
			sel_selector = "<div class='fw_select_selector'>" + placeholder + "</div>";
			
			sel_options = "<div class='fw_options'></div>";
			
			fwselect = jQuery(sel_container);
			fwselect = fwselect.append(sel_selector);
			
			jQuery.each(sel_options_arr, function(index, value)
			{
				option = jQuery(value.html);
				option.attr("data-fw_value", value.value);
				option.attr("data-fw_displayvalue", value.displayvalue);
				sel_options = jQuery(sel_options).append(option);
			});
			
			fwselect.append(sel_options);
			jQuery(sel_options).css("display", "none");
			
			jQuery(this).after(fwselect);
			jQuery(this).css("display", "none");
			
			name = jQuery(this).attr("name");
			jQuery(this).removeAttr("name");
			newInput = jQuery("<input/>");
			newInput.css("display", "none");
			
			newInput.attr("name", name);
			jQuery(this).next(".fw_select_container").append(newInput);
			jQuery(this).css("display", "none");
			
			
			//bind events
			jQuery(this).next(".fw_select_container").children(".fw_select_selector").bind("click", function()
			{
				if(!jQuery(this).hasClass("fw_opened"))
				{
					jQuery(this).addClass("fw_opened");
					jQuery(this).next(".fw_options").css("display", "block");
				}
				else
				{
					jQuery(this).removeClass("fw_opened");
					jQuery(this).next(".fw_options").css("display", "none");	
				}
			});
			
			jQuery(this).next(".fw_select_container").find(".fw_option").bind("click", function()
			{
				value = jQuery(this).data("fw_value");
				displayvalue = jQuery(this).data("fw_displayvalue");
				jQuery(this).parents(".fw_select_container").children("input").val(value);
				jQuery(this).parents(".fw_select_container").children(".fw_select_selector").trigger("click");
				jQuery(this).parents(".fw_select_container").children(".fw_select_selector").html(displayvalue);
			});
		});
	}

})(jQuery);

jQuery(window).load(function()
{
	jQuery.framework.select();
});
